export const BolLocationOptions = {
    Order_BOL: "ORCSH#",
    Order_PO: "ORCNS#",
    Stop_Reference: "",
};
